import { MutableRefObject, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';

interface IPrivacyPolicyModal {
  show: boolean;
  onHide: any;
  onOk: any;
}

const PrivacyPolicyModal = (props: IPrivacyPolicyModal) => {
  const okButtonEl = useRef() as MutableRefObject<HTMLButtonElement>;

  return (
    <Modal
      show={props.show}
      size="lg"
      onHide={props.onHide}
      centered /*onEntered={() => okButtonEl?.current?.focus()}*/
    >
      <Modal.Body className="text-14">
        <div className="gb-inside-container">
          <h4 className='text-center'>Privacy Statement</h4>
          <p>
            <br />
            The purpose of this document ("<strong>Data Protection Policy</strong>") is to inform you how STRIDES Premier Pte
            Ltd manages Personal Data (as defined below) in accordance with the Singapore Personal Data
            Protection Act 2012. Please take a moment to read this Data Protection Policy so that you are aware
            of and understand the purposes for which we collect, use and disclose your Personal Data.
            <br />
            <br />
            By interacting with us, submitting information to us or signing up for any promotions or services offered
            by us, you agree and consent to STRIDES Premier Pte Ltd and its related corporations (collectively,
            the "<strong><u>Companies</u></strong>"), as well as our respective representatives and/or agents ("<strong><u>Representatives</u></strong>")
            (collectively referred to herein as "<strong><u>SPPL</u></strong>", "<strong><u>us</u></strong>", "<strong><u>we</u></strong>" or "<strong><u>our</u></strong>") collecting, using, disclosing and sharing
            your Personal Data amongst ourselves, and disclosing such Personal Data to our authorised service
            providers and relevant third parties in the manner set forth in this Data Protection Policy.
            <br />
            <br />
            This Data Protection Policy supplements but does not supersede nor replace any other consents you
            may have previously provided to SPPL in respect of your Personal Data, and your consents herein are
            cumulative and additional to any rights which we may have under applicable law to collect, use or
            disclose and/or otherwise process your Personal Data.
            <br />
            <br />
            We may from time to time update this Data Protection Policy to ensure that this Data Protection Policy
            is consistent with our future developments, industry trends and/or any changes in legal or regulatory
            requirements, and may notify you of updates in any form we deem appropriate or, where required by
            applicable law, by posting a notice or reaching you via other forms of communication (e.g. sending you
            a SMS message or email or giving you a phone call) according to such contact particulars that we may
            have for you in our records from time to time. To the maximum extent permissible under applicable law,
            you agree to be bound by the prevailing terms of the Data Protection Policy as updated from time to
            time on our website and/or as you may be notified. Hence, please check back regularly for updated
            information on the handling or processing of your Personal Data.
            <br />
            <br />
            Use of our electronic services (including without limitation our websites, platforms, and applications) is
            also subject to our Terms of Use, available at <a href='https://stridespremier.com.sg/terms-of-use'>https://stridespremier.com.sg/terms-of-use</a> or via such
            other means as we may specify from time to time. For more information about our use of cookies, please
            refer to our Terms of Use.
            <br />
            <br />
            <p>
              <strong><u>1. PERSONAL DATA</u></strong>
            </p>

            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              1.1 In this Data Protection Policy, "<strong>Personal Data</strong>" refers to any data, whether true or not, about
              an individual who can be identified (a) from that data; or (b) from that data and other information
              to which we have or are likely to have access, including data in our records as may be updated
              from time to time.
            </p>

            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              1.2 Examples of such Personal Data you may provide to us include (depending on the nature of
              your interaction with us) your name, NRIC, passport or other identification number, telephone
              number(s), mailing address, email address, transactional data, and any other information
              relating to any individuals which you have provided us (including in the form of biometric data),
              or via other forms of interaction with us.
            </p>

            <p>
              <strong><u>2. COLLECTION OF PERSONAL DATA</u></strong>
            </p>

            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              2.1 Generally, we collect Personal Data in the following ways:
              <br /><br />
              <p className="gb-headline">
                (a) when you submit any form, including but not limited to registration, application, or
                declaration forms;
                <br /><br />
                (b) when you enter into any agreement or provide other documentation or information in
                respect of your interactions and transactions with us, or when you use our services;
                <br /><br />
                (c) when you interact with our staff and Representatives, including our customer service
                officers and other representatives, for example, via telephone calls (which may be
                recorded), letters, fax, face-to-face meetings, email, and/or via our electronic services;
                <br /><br />
                (d) when your images are captured by us via CCTV cameras while you are within our
                premises or photographs or videos taken by us or our Representatives when you attend
                events hosted by us;
                <br /><br />
                (e) when you interact with us or use our services provided through online and other
                technology platforms, such as websites, social media platforms and mobile application
                software;
                <br /><br />
                (f) when you share comments or feedback with us, such as through our electronic services
                or social media platforms, by contacting our Representatives;
                <br /><br />
                (g) when you request that we contact you, that you be included in an email or other mailing
                list; or when you respond to our requests for additional Personal Data, our promotions,
                and/or other initiatives;
                <br /><br />
                (h) when you are contacted by, and respond to, our marketing Representatives, agents,
                and/or other service providers;
                <br /><br />
                (i) when you submit an employment application, and/or your details in connection with an
                independent contractor engagement or when you provide documents or information
                (including without limitation your resume, your track records and expertise,
                employment history, and/or curriculum vitae) in connection with any appointment,
                engagement, or position with us, or when you attend interviews with us;
                <br /><br />
                (j) when we receive your Personal Data from business partners, public agencies, your
                employer or other third parties;
                <br /><br />
                (k) where allowed under applicable law, when we seek information from third parties about
                you in connection with your relationship with us, including without limitation in
                connection with our services and/or employment applications submitted to us, for
                example, from business partners, public agencies, your ex-employer, and/or the
                relevant authorities; and/or
                <br /><br />
                (l) when you submit your Personal Data to us for any other reasons.
              </p>
            </p>

            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              2.2 If you provide us with any Personal Data relating to a third party (e.g. information of spouse,
              minors, children, parents, employees and/or authorised persons), by submitting such
              information to us, you represent to us that you have obtained the consent of such third party to
              you providing us with their Personal Data, and for the collection, use and disclosure of their
              Personal Data for all purposes set out in our herein and by or for the benefit of the persons
              referenced herein.
            </p>

            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              2.3 You should ensure that all Personal Data submitted to us is complete, accurate, true and
              correct. Failure to do so on your part may result in our inability to provide you with the products
              and/or services which you have requested.
            </p>


            <p>
              <strong><u>3. PURPOSES FOR THE COLLECTION, USE AND DISCLOSURE OF YOUR PERSONAL DATA</u></strong>
            </p>

            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              3.1 Generally, SPPL collects, uses and discloses your Personal Data for the following purposes:
              <br /><br />
              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (a) responding to, processing and handling your complaints, queries, requests, feedback
                and suggestions or otherwise providing customer support;
                <br /><br />
                (b) managing the administrative and business operations of the Companies and
                complying with our internal policies and procedures;
                <br /><br />
                (c) facilitating business asset transactions (which may extend to mergers, acquisitions,
                debt or asset sales) involving any of the Companies;
                <br /><br />
                (d) matching any Personal Data held which relates to you for any of the purposes listed
                herein;
                <br /><br />
                (e) verifying your identity and/or facilitating and carrying out due diligence checks;
                <br /><br />
                (f) requesting feedback or participation in surveys, as well as conducting market
                research and/or analysis for statistical, profiling or other purposes for us to design our
                products, understand commuters' behaviour, customer behaviour, preferences, and
                market trends, and to review, develop and improve the quality of our products and/or
                services;
                <br /><br />
                (g) preventing, detecting, and investigating crime (including fraud and money-laundering
                or terrorist financing), analysing and managing the safety and security of our premises
                and services (including but not limited to carrying out CCTV surveillance and
                conducting security clearances);
                <br /><br />
                (h) project management, conducting audits, reviews and analysis of our internal
                processes, action planning, analysing and managing commercial risks and managing
                and preparing reports on incidents and accidents;
                <br /><br />
                (i) providing media announcements and responses;
                <br /><br />
                (j) organising promotional events;
                <br /><br />
                (k) in connection with any claims, actions or proceedings (including but not limited to
                drafting and reviewing documents, transaction documentation, obtaining legal advice,
                and facilitating dispute resolution), and/or protecting and enforcing our contractual and
                legal rights and obligations;
                <br /><br />
                (l) meeting or complying with any applicable rules, laws, regulations, codes of practice
                or guidelines issued by any legal or regulatory bodies, and/or assisting with any
                enquiries, requests, or investigations by relevant authorities (including but not limited
                to disclosures to regulatory bodies or conducting audit checks, surveillance,
                investigation, and/or due diligence); and/or
                <br /><br />
                (m) any other purpose relating to or reasonably necessary for any of the above.
              </p>
            </p>
            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              These purposes may also apply even if you no longer utilise any of our services.
            </p>
            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              3.2 In addition, SPPL collects, uses and discloses your Personal Data for the following purposes,
              depending on the nature of our relationship:
              <br /><br />

              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (a) If you are a customer or prospective customer of SPPL (for example, if you are a
                passenger on our trains, buses or taxis):
                <br /><br />
                <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                  (i) processing taxi bookings;
                  <br /><br />
                  (ii) providing customer service and administering benefits (including but not
                  limited to fare ticketing and providing rewards, rebates and other promotions);
                  <br /><br />
                  (iii) verifying and processing your personal particulars and payment in relation to
                  the purchase or provision of goods and/or services;
                  <br /><br />
                  (iv) providing you with goods and/or services which you have purchased or
                  requested to receive, and to provide content to you which may be relevant to
                  you (including to personalise and customise your experience based on your
                  interactions with us), your profile information and preferences, and other
                  content you submit from time to time;
                  <br /><br />
                  (v) communicating with you and informing you of changes and development to our
                  policies, terms and conditions and other administrative information, including
                  for the purposes of servicing you in relation to the products and services
                  offered to you;
                  <br /><br />
                  (vi) managing and preparing reports on incidents, offences and accidents; and/or
                  <br /><br />
                  (vii) investigating and processing compensation claims;
                </p>
              </p>

              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (b) If you are an employee, business partner, director or representative of an
                organisation that is a corporate customer, business partner or otherwise has a
                corporate relationship with SPPL:
                <br /><br />
                <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                  (i) conducting background screenings and due diligence checks; and/or
                  <br /><br />
                  (ii) facilitating the bidding of tenders;
                  <br /><br />
                </p>
              </p>

              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (c) If you are a taxi partner with SPPL:
                <br /><br />
                <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                  (i) administration in relation to the leasing of taxis (including but not limited to
                  processing taxi licenses and rental payments);
                  <br /><br />
                  (ii) facilitating the continuation or termination of the leasing relationship (including but not limited to maintenance of records, processing lease renewals
                  and providing regular updates and communications);
                  <br /><br />
                  (iii) administering programmes and benefits;
                  <br /><br />
                  (iv) facilitating the advertising of our taxi services;
                  <br /><br />
                  (v) processing claims;
                  <br /><br />
                  (vi) management of vehicle servicing;
                  <br /><br />
                  (vii) facilitating training, learning and talent development;
                  <br /><br />
                  (viii) facilitating the enforcement of repayment obligations and approval of bad
                  debts; and/or
                  <br /><br />
                  (ix) enabling us to respond to emergencies;
                  <br /><br />
                </p>
              </p>

              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (d) If you are a tenant at our retail premises:
                <br /><br />
                <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                  (i) facilitating the leasing of properties;
                  <br /><br />
                  (ii) administration in relation to the leasing of properties (including but not limited
                  to handing and taking over of properties and processing payments); and/or
                  <br /><br />
                  (iii) facilitating the continuation or termination of the leasing relationship (including but not limited to maintenance of tenant records, processing tenancy
                  renewals and providing regular updates and communications);
                  <br /><br />
                </p>
              </p>

              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (e) If you are an existing or prospective external service provider, vendor, contractor,
                subcontractor or consultant or an employee thereof (where applicable) of SPPL:
                <br /><br />
                <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                  (i) providing information on upcoming tenders;
                  <br /><br />
                  (ii) procuring, awarding and managing project tenders (including but not limited
                  to procuring approval from relevant government regulators, government
                  ministries, statutory boards or authorities);
                  <br /><br />
                  (iii) managing the outsourcing relationship;
                  <br /><br />
                  (iv) facilitating training, learning and talent development;
                  <br /><br />
                  (v) processing and payment of invoices and claims;
                  <br /><br />
                  (vi) managing project developments and communications;
                  <br /><br />
                  (vii) supervising operational matters; and/or
                  <br /><br />
                  (viii) managing the security of the premises (including but not limited to conducting
                  security screening and issuing contractor access passes);
                  <br /><br />
                </p>
              </p>

              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (f) If you submit an application to us as a candidate for employment / your engagement
                as an independent contractor:
                <br /><br />
                <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                  (i) conducting interviews;
                  <br /><br />
                  (ii) processing your application / engagement which includes pre-recruitment /
                  pre-engagement checks involving your qualifications and facilitating
                  interviews;
                  <br /><br />
                  (iii) providing or obtaining employee / customer references and for background
                  screening;
                  <br /><br />
                  (iv) assessing your suitability for the position or engagement applied for; and/or
                  <br /><br />
                  (v) managing and/or processing referrals; and/or
                  <br /><br />
                  (vi) verifying your identity and accuracy of your personal details and other
                  information provide;
                  <br /><br />
                </p>
              </p>

              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (g) if you are our employee, independent contractor, temporary staff, intern, or trainee:
                <br /><br />
                <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                  (i) administrative, human resources related and support processes relating to
                  your employment or relationship with us, including managing and terminating
                  your employment or appointment, staff benefits (including travel, manpower,
                  business continuity and logistical management or support), processing
                  expense claims, administering insurance applications, leave administration,
                  training, learning and talent development, resolving grievances, and planning
                  and organising corporate events;
                  <br /><br />
                  (ii) investigating any acts or defaults (or suspected acts or defaults), or
                  contraventions of our internal or external compliance obligations;
                  <br /><br />
                  (iii) providing you with tools and facilities to enable or facilitate the performance of
                  your duties, and monitoring your use of such tools and facilities;
                  <br /><br />
                  (iv) ensuring business continuity, including compiling and publishing internal
                  directories and emergency contact lists;
                  <br /><br />
                  (v) ensuring that our operations function in a secure, efficient and effective manner
                  (including examining or monitoring any computer software and hardware
                  installed by us, located in our premises, or under our control, your activities on
                  such computer software and hardware, your internet access, your work emails
                  and personal digital and storage devices); and/or
                  <br /><br />
                  (vi) performing obligations under or in connection with your contract of
                  employment or relationship with us, such as payment of remuneration and tax;
                  <br /><br />
                </p>
              </p>

              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (h) If you are a SPPL shareholder:
                <br /><br />
                <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                  (i) maintaining statutory registers and managing the publication of shareholder
                  statistics on annual reports and circulars; and/or
                  <br /><br />
                  (ii) facilitating shareholder analysis (including but not limited to profiling
                  shareholders, identifying investors and scheduling shareholder meetings);
                  <br /><br />
                </p>
              </p>

              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (i) If you sit on the SPPL Board of Directors:
                <br /><br />
                <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                  (i) facilitating appointment to the Board (including but not limited to managing
                  the publication of directors' statistics on annual reports and circulars); and/or
                  <br /><br />
                  (ii) facilitating the execution of duties and administrative matters (including but
                  not limited to maintaining statutory registers, delivering meeting agendas,
                  processing both local and overseas tax filing and organising corporate events);
                  and/or
                  <br /><br />
                </p>
              </p>
              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (j) processing of your Personal Data in relation to any of the purposes stated above.
              </p>
            </p>
            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              3.3 In addition, where permitted under applicable law, we may also collect, use and disclose your
              Personal Data for the following purposes (which we may describe in our documents and
              agreements as "<strong>Additional Purposes</strong>" for the handling of Personal Data):
              <br /><br />
              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (a) providing or marketing promotions, products, services and/or benefits to you, including
                loyalty and reward programmes as well as joint marketing and/or cross-promotions with
                third parties;
                <br /><br />
                (b) matching Personal Data with other data collected for other purposes and from other
                sources (including third parties) in connection with the provision or offering of
                promotions, products and services, whether by SPPL or other third parties;
                <br /><br />
                (c) organising marketing and promotional events, administering contests and
                competitions, and personalising your experience at SPPL's touchpoints;
                <br /><br />
                (d) sending you details of promotions, services, special offers and rewards, either to our
                customers generally, or which we have identified may be of interest to you;
                <br /><br />
                (e) conducting market research, understanding and analysing customer behaviour,
                location, preferences and demographics for us to offer you products and services as
                well as special offers and marketing programmes which may be relevant to your
                preferences and profile; and/or
                <br /><br />
                (f) recommending, identifying and/or contacting you to inform you of products, services,
                special offers and rewards, either to our customers generally, or which we have
                identified may be of interest to you, or that are or may be relevant to you, in any case
                including on behalf of third parties, or sharing your Personal Data with such third parties
                or their service providers for them to collect, use, disclose or process your Personal
                Data for any of such purposes.
                <br /><br />
              </p>
            </p>

            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              3.4 If you have provided your Singapore telephone number(s) and you have (i) indicated that you
              consent to receiving marketing or promotional information via your Singapore telephone
              number(s), (ii) not registered with the Do Not Call Registry, or (iii) the sending of such marketing
              or promotional information is permissible under applicable laws and regulations, then from time
              to time, SPPL may contact you using such Singapore telephone number(s) (including via voice
              calls, text, fax or other means) with information about our promotions, products and services
              (including discounts and special offers). You have the right to withdraw your consent regarding
              the marketing or promotional information you receive at any time by contacting the
              appropriate Representative. Such requests will be processed within 21 days. Please note that
              after opting out, you may still continue to receive non-marketing messages, such as product
              updates and service notices as permitted under applicable laws and regulations.
              <br /><br />
            </p>

            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              3.5 In relation to particular products or services or in your interactions with us, we may also have
              specifically notified you of other purposes for which we collect, use or disclose your Personal
              Data. If so, we may collect, use and disclose your Personal Data for these additional purposes
              as well, unless we have specifically notified you otherwise.
              <br /><br />
            </p>

            <p>
              <strong><u>4. DISCLOSURE OF PERSONAL DATA</u></strong>
            </p>

            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              4.1 SPPL will take reasonable steps to protect your Personal Data against unauthorised
              disclosure. Subject to the provisions of any applicable law, your Personal Data may be
              provided, for the purposes listed above (where applicable), to the following entities or parties,
              whether they are located overseas or in Singapore:
              <br /><br />
              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (a) SPPL's related corporations;
                <br /><br />
                (b) companies or brokers providing services relating to insurance and/or reinsurance to
                SPPL;
                <br /><br />
                (c) agents, contractors or third party service providers who provide operational services
                to SPPL, such as vehicle servicing and towing, courier services, telecommunications,
                information technology, advertising, payment, payroll, processing, training, market
                research, storage, archival, customer support investigation services or other services
                to SPPL;
                <br /><br />
                (d) vendors or other third party service providers in connection with promotions and
                services offered by SPPL;
                <br /><br />
                (e) any business partner, investor, assignee or transferee (actual or prospective) to facilitate business asset transactions (which may extend to merger, acquisition, debt or asset sales) involving any of the Companies;
                <br /><br />
                (f) banks, credit card companies, financial institutions, and their respective service providers;
                <br /><br />
                (g) third party referrers;
                <br /><br />
                (h) our co-brand and other business partners;
                <br /><br />
                (i) our professional advisers such as our consultants, auditors and lawyers;
                <br /><br />
                (j) relevant government regulators, government ministries, statutory boards or
                authorities and/or law enforcement agencies, whether local or overseas, including the Land Transport Authority, to comply with any directions, laws, rules, guidelines, regulations or schemes issued or administered by any of them;
                <br /><br />
                (k) external business and charity partners in relation to corporate promotional events;
                and/or
                <br /><br />
                (l) any other party to whom you authorise us to disclose your Personal Data to.
                <br /><br />
              </p>
            </p>

            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              4.2 We may also share information about you in aggregate or anonymised form (such as generic
              aggregated demographic information regarding visitors and users) with the abovementioned
              parties.
              <br /><br />
            </p>
            <p>
              <strong><u>5. DEEMED CONSENT</u></strong>
            </p>
            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              5.1 In addition to the matters set forth above, subject to and in accordance with applicable law, you
              shall be <u>deemed to have consented</u> to us collecting, using, disclosing and sharing amongst
              ourselves your Personal Data, and disclosing such Personal Data to our authorised service
              providers and relevant third parties:
              <br /><br />
              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (a) where in response to a request for your Personal Data in connection with identified
                purposes, you voluntarily provide such Personal Data to us for such purpose(s) and it
                is reasonable that you would voluntarily provide such Personal Data; and
                <br /><br />
                (b) where the collection, use and/or disclosure of your Personal Data is reasonably
                necessary for the conclusion and/or performance of a contract, between you and us or
                any other organisation entered into at your request, which may include recipients of
                your Personal Data not indicated in this Data Protection Policy.
                <br /><br />
              </p>
            </p>

            <p>
              <strong><u>6. OTHER BASES FOR HANDLING OR PROCESSING YOUR PERSONAL DATA</u></strong>
            </p>
            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              6.1 In addition to and without limiting the consents you have provided to our collection, use and/or
              disclosure of your Personal Data for the purposes set out elsewhere in this Data Protection
              Policy, where permitted by applicable law, we may in accordance with the requirements thereof
              also collect, use and/or disclose your Personal Data as further detailed below including without
              consent, where we meet the requirements under applicable law:
              <br /><br />
              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (a) for our legitimate interests or the legitimate interests of another person (but not for
                sending you direct marketing messages unless you have otherwise provided your
                consent), including without limitation for the following purposes:
                <br /><br />
                <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                  (i) any investigations or proceedings;
                  <br /><br />
                  (ii) fraud detection and prevention;
                  <br /><br />
                  (iii) entering into, managing or terminating an employment relationship or
                  appointment;
                  <br /><br />
                  (iv) to recover a debt owed by you to us or to pay a debt owed by us to you;
                  <br /><br />
                  (v) to obtain legal services;
                  <br /><br />
                  (vi) detection and prevention of misuse of services by users; and
                </p>
                (b) we may collect your Personal Data from any of the Companies, we may use your
                Personal Data, and any of the Companies may disclose your Personal Data to us, for
                improving our products, services, processes or business, understanding customer
                preferences and personalising experiences and recommendations (regardless whether
                you are an existing or prospective customer of any of the Companies).
                <br /><br />
              </p>
            </p>

            <p>
              <strong><u>7. CONTACTING US - QUESTIONS, FEEDBACK, WITHDRAWAL OF CONSENT, ACCESS
                AND CORRECTION OF YOUR PERSONAL DATA</u></strong>
            </p>

            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              7.1 If you:
              <br /><br />
              <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
                (a) have any questions or feedback relating to your Personal Data or our Data Protection
                Policy (including without limitation our reliance on deemed consent or other bases for
                collecting, using, and/or disclosing your Personal Data);
                <br /><br />
                (b) would like to withdraw your consent to any use of your Personal Data as set out in this
                Data Protection Policy; or
                <br /><br />
                (c) would like to obtain access or make corrections to your Personal Data records,
              </p>
              please contact our data protection officer as follows: <strong><a href="mailto:dpo@smrt.com.sg">dpo@smrt.com.sg</a></strong>
            </p>

            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              7.2 Please note that if your Personal Data has been provided to us by a third party (e.g. a
              recruitment agency), you should contact such party directly to make any queries, feedback, and
              access and correction requests to us on your behalf.
            </p>
            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              7.3 If you withdraw your consent to any or all collection, use, and/or disclosure of your Personal
              Data, depending on the nature of your request, we may not be in a position to continue to
              provide our services to you and/or administer any contractual relationship in place. Such
              withdrawal of consent may also result in the termination of any agreements with you, and your
              being in breach of your contractual obligations or undertakings. Our legal rights and remedies
              in such event are expressly reserved. Please also note that withdrawing consent does not affect
              our right to continue to process Personal Data where such processing without consent is
              permitted or required under applicable laws.
              <br /><br />
            </p>
            <p>
              <strong><u>8. GOVERNING LAW</u></strong>
            </p>
            <p className="gb-headline gb-headline-c12381c9 gb-headline-text">
              8.1 This Data Protection Policy shall be governed in all respects by the laws of Singapore.
              <br /><br />
            </p>
          </p>
        </div>
        <div className="text-center">
          <Button
            variant="danger"
            className="mr-2 text-15 font-weight-bold"
            onClick={() => props.onOk()}
            ref={okButtonEl}
            tabIndex={-1} // Enables key handlers on div
          >
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PrivacyPolicyModal;
